/* eslint-disable react-hooks/exhaustive-deps */
/*
  Popover component
  example:
  <Popover content={<h1>Popupcontent</h1>}>Handler</Popover>
*/

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-tiny-popover';
import styled, { withTheme, ThemeProvider } from 'styled-components/macro';
import { themeType } from 'types';

import { IntlProvider } from 'react-intl';
import pt from 'data/messages/pt'
import languages from 'data/languages'

const { defaultLangKey } = languages
const messages = { pt }

const PopoverBase = ({
  theme,
  position,
  children,
  content,
  align,
  handlerWidth,
  onChangeOpen,
  triggerClose,
  ...rest
}) => {
  const [isOpen, setOpen] = useState(false);
  const handleClick = (e) => {
    e.preventDefault()
    setOpen(!isOpen)
  };

  useEffect(() => {
    onChangeOpen(isOpen)
  }, [isOpen])

  useEffect(() => {
    if (isOpen) setOpen(false)
  }, [triggerClose])

  return (
    <Popover
      transitionDuration="0"
      isOpen={isOpen}
      position={position}
      align={align}
      content={
        () => (
          <IntlProvider locale={defaultLangKey} messages={messages[defaultLangKey]}>
            <ThemeProvider theme={theme}>
              {content}
            </ThemeProvider>
          </IntlProvider>
        )}
      onClickOutside={() => setOpen(false)}
      containerStyle={{
        overflow: 'visible',
        backgroundColor: theme.colors.bg,
        boxShadow: theme.shadows.card,

        border: `1px solid ${theme.colors.borderLighter}`,
        zIndex: '9999',
      }}
      {...rest}
    >
      <Handler onClick={handleClick} width={handlerWidth}>
        {children}
      </Handler>
    </Popover>
  );
};

const Handler = styled.div`
  cursor: pointer;
  width: ${props => (typeof props.width === 'number' ? `${props.width}px` : props.width)};
  height: fit-content;
`;

PopoverBase.propTypes = {
  theme: themeType.isRequired,
  position: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
  align: PropTypes.oneOf(['start', 'center', 'end']),
  children: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  handlerWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChangeOpen: PropTypes.func,
  triggerClose: PropTypes.bool,
};

PopoverBase.defaultProps = {
  position: 'top',
  align: 'end',
  handlerWidth: 'auto',
  onChangeOpen: () => { },
  triggerClose: false,
};

export default withTheme(PopoverBase);
